import { evidenceItems } from "@/mocks/evidence";
import EvidenceCard from "@/components/feature/EvidenceCard";
import { SectionHeading } from "@/components/feature/PageHero";

export default function EvidencePreview() {
  const preview = [evidenceItems[0], evidenceItems[2]];

  return (
    <section className="w-full bg-background-50 px-4 py-12 md:px-6 md:py-16 lg:px-10">
      <SectionHeading
        title="证据对照速览"
        description="把互相竞争的说法并排放，看它们哪里一致、哪里打架。矛盾本身也是有用信息，所以它同样被标注出来。"
        action={{ label: "进入证据对照室", to: "/evidence" }}
      />
      <div className="grid grid-cols-1 gap-5 lg:grid-cols-2">
        {preview.map((item) => (
          <EvidenceCard key={item.id} item={item} />
        ))}
      </div>
    </section>
  );
}